import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import Heading from '../ui/Heading'
import Slider from 'react-slick'

import Khon2 from '../../../../../Assets/nokaoi-imges/as-seen-img/Khon2.png'
import good from '../../../../../Assets/nokaoi-imges/as-seen-img/good.png'
import staradvertise from '../../../../../Assets/nokaoi-imges/as-seen-img/staradvertise.svg'
import islandnews from '../../../../../Assets/nokaoi-imges/as-seen-img/islandnews.png'
import jack from '../../../../../Assets/nokaoi-imges/as-seen-img/jack.png'
import npr from '../../../../../Assets/nokaoi-imges/as-seen-img/npr.png'
import hawaii from '../../../../../Assets/nokaoi-imges/as-seen-img/hawaii.png'
import { ImageUrl } from '../../../../../Helpers/request'

const AsSeenOn = () => {

    const mediaLogos = [
        {
            image: Khon2,
            link: 'https://www.khon2.com/local-news/a-maui-jeweler-bringing-sparkle-back-to-lahaina/', 
        },
        {
            image: good,
            link: 'https://www.goodnewsnetwork.org/maui-jewelry-store-restores-jewelry-damaged-by-wildfires-for-free/', 
        },
        {
            image: staradvertise,
            link: 'https://www.staradvertiser.com/2023/12/25/hawaii-news/kahului-jewelers-restore-burned-jewelry-for-maui-fire-survivors-at-no-cost/', 
        },
        {
            image: islandnews,
            link: 'https://www.kitv.com/news/lahaina/its-the-most-rewarding-feeling-good-samaritan-restores-maui-fire-survivors-jewelry/article_d84de704-880c-11ee-a762-336d3af867d8.html', 
        },
        {
            image: jack,
            link: 'https://www.jckonline.com/editorial-article/maui-jeweler-wildfire-jewelry/', 
        },
        {
            image: npr,
            link: 'https://www.npr.org/2023/12/30/1220096055/maui-wildfires-ruined-personal-treasures-a-local-jeweler-is-repairing-items-for-', 
        },
        {
            image: hawaii,
            link: 'https://www.hawaiinewsnow.com/2023/11/24/jeweler-finds-way-give-back-lahaina-restoring-precious-items-scarred-by-fire/', 
        },
    ];


    let settings2 = {
        dots: false,
        infinite: true,
        speed: 500,
        accessibility: true,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        prevArrow: <Image src={`${ImageUrl}theme/showcase/left.png`} alt="arrow" />,
        nextArrow: <Image src={`${ImageUrl}theme/showcase/right.png`} alt="arrow" />,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4, arrows: false, dots: true } },
             { breakpoint: 991, settings: { slidesToShow: 3, arrows: false, dots: true } },
            { breakpoint: 768, settings: { slidesToShow: 3, arrows: false, dots: true } },
             { breakpoint: 600, settings: { slidesToShow: 2, arrows: false, dots: true } },
        ],
    };
    return (
        <div className='no_as_seen_on_section'>
            <Container>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <Heading>
                            <h2>As Seen On</h2>
                        </Heading>
                    </Col>
                    <Col sm={12} md={12} lg={12}>
                        <Slider {...settings2}>
                            {mediaLogos.map((item, index) => (
                                <div className="as_Seen_media_item_outer">
                                    <div className='as_Seen_media_item_inner'>
                                        <Image src={item.image} alt="media logo" className='img-fluid' onClick={() => window.open(item.link, '_blank')} />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default AsSeenOn
